<template>
  <div class="banner-list-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="banner:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 添加 Banner</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #image="{ row }">
        <img class="image" :src="row.image" alt="" srcset="">
      </template>
      <template #mallName="{ row }">
        <el-tooltip placement="right" effect="light">
          <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ row.mallName }}</div>
          <div style="white-space: pre-wrap; min-width: 160px; max-height: 200px; overflow: auto;" slot="content">
            <div v-for="(item,index) in (row.mallName ? row.mallName.split(',') : [])" :key="index">{{ item }}</div>
          </div>
        </el-tooltip>
      </template>
      <template #sort="{ row }">{{ row.sort }}</template>
      <template #enableB="{ row }">
        <auth-button auth="banner:switch" :elseInfo="row.enableB ? '开启' : '关闭'">
          <el-switch
            :value="row.enableB"
            disabled
            active-color="#05C8AF"
            inactive-color="#F2F3F5"
            @click.native="onStatusChange(row)"
          >
          </el-switch>
        </auth-button>
      </template>
      <template #type="{ row }">{{ onType(row.type) }}</template>
      <template #url="{ row }">{{ row.url?row.url:'---' }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <auth-button auth="banner:update">
          <el-button type="text" @click="onEdit(scope.row)" class="mr10">编辑</el-button>
        </auth-button>
        <auth-button auth="banner:delete">
          <el-button class="del" type="text" @click="onDelete(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getBanner, api_putBannerStatus, api_deleteBanner } from '@/api/banner'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "PopCouponListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "Banner名称",
          placeholder: "请输入Banner名称",
          type: "input",
          key: "name",
        },{
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "mall",
          key: "mallIds",
        },
      ],
      form: {},
      tableThData: [
        { prop: "name", label: "名称", minWidth: "180", },
        { prop: "image", label: "图片", minWidth: "180", },
        { prop: "mallName", label: "商场", minWidth: "180", },
        { prop: "sort", label: "序号", minWidth: "100", },
        { prop: "enableB", label: "状态", minWidth: "100", },
        { prop: "type", label: "跳转类型", minWidth: "100", },
        { prop: "url", label: "跳转链接", minWidth: "180", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "100", },
      ],
    };
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        showType:'Banner',
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getBanner(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.tableTrData = this.tableTrData.map((item) => {
        return {
          ...item,
          enableB: item.enable === 1
        }
      })
      this.total = data.count
      this.loading = false
    },
    // 点击创建按钮
    onAdd() {
      this.$router.push({
        path: "/serverConfig/bannerList/add?showType=Banner"
      })
    },
    // 跳转链接类型枚举
    onType(type) {
      switch (type) {
        case 'base':
         return '内部链接'
        case 'out':
         return '外部链接'
          case 'text':
         return '富文本'
          case 'miniprogram':
         return '小程序跳转'
          case 'poster':
         return '海报弹窗'
        default:
          break;
      }
    },
    // 更改banner状态
    async onStatusChange(row) {
      let newRow = JSON.parse(JSON.stringify(row))
      newRow.enableB = !row.enableB
      newRow.enable = row.enable === 1 ? 0 : 1
      this.$baseConfirm(
        row.enableB ? '是否隐藏该Banner？' : '是否显示该Banner？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          this.updateItem(newRow, ()=>{
            row.enable = newRow.enable
            row.enableB = newRow.enableB
          })
        }
      )
    },
    // 更新数据
    async updateItem (row, cb) {
      let {id} = row
      await api_putBannerStatus({id})
      this.$baseMessage('操作成功', 'success')
      cb()
    },
    onDelete (row) {
      this.$baseConfirm(
        '是否删除该Banner？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_deleteBanner({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },
    onEdit(row){
      this.$router.push({
        path: "/serverConfig/bannerList/add?id=" + row.id
      })
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.banner-list-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .del {
    color: #F74A4A;
  }
  ::v-deep{
    // 去除switch禁用 css
    .el-switch.is-disabled{
      opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
      cursor: pointer;
    }
  }
  .image{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
